<template>
  <div>
    <window-header></window-header>
    <section>
      <article style="height:395px;width:770px">
        <div class="emision-sidebar">
          <button :disabled="!formData.plantilla" @click="emitir(false)">
            <fa-icon icon="file-alt" size="2x" />
            Visualizar
          </button>
          <button :disabled="!formData.plantilla" @click="emitir(true)">
            <fa-icon icon="print" size="2x" />
            Imprimir
          </button>
          <button @click="app.openWindow('disenar_listados', { props: { model } })">
            <fa-icon icon="paint-brush" size="2x" />
            Diseñar
          </button>
          <button :disabled="!formData.plantilla">
            <fa-icon icon="envelope" size="2x" />
            Enviar por email
          </button>
        </div>
        <fieldset style="position: absolute; left: 110px; top: 5px; height: 62px; width: 648px">
          <legend>Imprimir</legend>
          <field name="plantilla" dbAdapter="plantilla_listado" :filter="[['model', '=', model]]" widget="m2o"
            width="600px" style="top:9px; left:17px;" />
        </fieldset>
        <!--<fieldset style="position: absolute; left: 110px; top: 70px; height: 62px; width: 300px">
          <legend>Datos de Selección</legend>
          <field name="seleccion1" widget="radio" :options="{
            'Pendientes de emitir': 'pendientes',
            'Emitidos': 'emitidos',
            'Todos': 'todos'
          }" inline-label style="top: 6px; left: 20px" />
        </fieldset>-->
        <fieldset v-if="model == 'cliente'"
          style="position: absolute; left: 110px; top: 70px; height: 72px; width: 300px">
          <legend>Parámetros</legend>
          <field name="fecha_desde" type="date" label="Desde" style="left: 10px; top: 5px;" />
          <field name="fecha_hasta" type="date" label="Hasta" style="left: 140px; top: 5px;" />
          <!--<field ref="parametros" name="parametros" widget="handsontable" :height="62" :minRows="0"
            style="top: 10px; left: 4px; width: 280px" :columns="[
              { name: 'nombre', header: 'Campo', readOnly: true },
            ]" />-->
        </fieldset>
        <fieldset v-if="model == 'cliente'"
          style="position: absolute; left: 420px; top: 70px; height: 72px; width: 300px">
          <legend>Orden</legend>
          <field name="orden" widget="select" label="Orden" style="left: 10px; top: 5px;" :options="{
            'Suma bases facturas': 'suma_bases_facturas',
            'Código': 'codigo',
            'NIF/CIF': 'nif_cif',
            'Nombre comercial': 'nombre_comercial',
            'Nombre fiscal': 'nombre_fiscal',
          }" />
          <field widget="radio" name="orden_dir" :options="{
            'ASC': 'asc',
            'DESC': 'desc'
          }" inline-label style="left: 180px; top: 17px;" />
        </fieldset>
        <filtro-seleccion-acotacion ref="selaco" style="left: 110px; top: 150px;"
          :referencia="'emitir_listado_' + model" :model="model" :nombre="'Emitir listado. ' + subtitulos[model]" />
      </article>
    </section>
  </div>
</template>
<script>
import WindowMixin from "./../components/WindowMixin.vue";
import rFormMixin from "./../components/rFormMixin.vue";
import FiltroSeleccionAcotacion from "./../components/FiltroSeleccionAcotacion.vue";

// TODO: default plantilla

let subtitulos = {
  cliente: 'Clientes',
  factura_cliente: 'Facturas de cliente',
  albaran_cliente: 'Albaranes de cliente',
  pedido_cliente: 'Pedidos de cliente',
};

export default {
  mixins: [WindowMixin, rFormMixin],
  components: { FiltroSeleccionAcotacion },
  props: {
    model: {
      required: true,
      type: String
    }
  },
  data: function () {
    var self = this;
    return {
      title: "Emitir listado: " + subtitulos[self.model],
      mode: 'new',
      dbAdapter: "xxx",
      primary: "codigo",
      formData: {
        plantilla: self.app.config['plantilla_listado_' + self.model],
        orden: self.model == 'cliente' && 'suma_bases_facturas',
        orden_dir: self.model == 'cliente' && 'desc'
      },
      subtitulos
    };
  },
  mounted: function () {
    //var $ = window.$;
  },
  methods: {
    emitir: function (print = false) {
      let self = this;
      let conditions = self.$refs.selaco.getFilter();
      if (self.model == 'cliente') {
        conditions.push(['suma_bases_facturas', '>', 0]);
      }
      let params = {
        fecha_desde: self.formData.fecha_desde,
        fecha_hasta: self.formData.fecha_hasta,
      };
      let obj = {
        id: self.formData.plantilla.codigo,
        print: print ? 1 : null,
        conditions,
        token: window.session.token,
        params,
        orden: [{
          col: self.formData.orden,
          dir: self.formData.orden_dir,
          params
        }]

      }
      let serparams = window.$.param(obj);
      window.open(
        self.app.urlGeneradorInformesListadoPrint + "&" + serparams,
        "_blank"
      );
      //self.$emit("close");
    }
  },
};
</script>
<style>
.emision-sidebar {
  display: flex;
  flex-direction: column;
  width: 100px;
}

.emision-sidebar button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: var(--padding-half);
  padding: var(--padding-half);
}
</style>
